import { Dexie } from 'dexie';

export const db = new Dexie('aplikacja');

db.version(1).stores({
    user: '++index',
    token: '++index',
});

db.open().catch(function (err) {
    console.error (err.stack || err);
});